document.addEventListener("DOMContentLoaded", initCountdown);

const Countdown = {

    duration: 24,

    endTime: 0,

    timer: null,

    elements: {},

    storageKey: "",

    currentState: "",

    previousState: "",

    debugState: null,

};

function initCountdown() {

    const section =
        document.querySelector(".promo-countdown");

    if (!section) return;

    Countdown.section = section;
    Countdown.preview =
    section.dataset.preview;

    Countdown.duration =
        parseInt(section.dataset.duration || 24);

    Countdown.autoRestart =
        section.dataset.restart === "true";

        Countdown.elements = {

        hours:
            section.querySelector(".promo-hours"),

        minutes:
            section.querySelector(".promo-minutes"),

        seconds:
            section.querySelector(".promo-seconds"),

        message:
            section.querySelector("#promo-message")

    };

    Countdown.messages = {

        normal:
            Countdown.elements.message.dataset.normal,

        limited:
            Countdown.elements.message.dataset.limited,

        fast:
            Countdown.elements.message.dataset.fast,

        final:
            Countdown.elements.message.dataset.final,

        last:
            Countdown.elements.message.dataset.last

    };

    startCountdown();

}

function startCountdown() {

    const cycle =
    Countdown.duration * 60 * 60 * 1000;

const now =
    Date.now();

Countdown.endTime =
    now - (now % cycle) + cycle;

    updateCountdown();

    Countdown.timer =
        setInterval(updateCountdown, 1000);

}

function updateCountdown() {

    let diff =
        Countdown.endTime - Date.now();

    if (diff <= 0) {

    if (Countdown.autoRestart) {

        const cycle =
    Countdown.duration * 60 * 60 * 1000;

const now =
    Date.now();

Countdown.endTime =
    now - (now % cycle) + cycle;

        diff =
            Countdown.endTime - Date.now();

    } else {

        diff = 0;

        clearInterval(Countdown.timer);

   }

}

    const total =
    Math.floor(diff / 1000);

const hours =
    Math.floor(total / 3600);

const minutes =
    Math.floor((total % 3600) / 60);

const seconds =
    total % 60;

renderTime(hours, minutes, seconds);

const state =
    Countdown.debugState ??
    getCurrentState(hours, minutes);

if(state !== Countdown.currentState){

    Countdown.currentState = state;

    Countdown.section.classList.add("flash");

    setTimeout(() => {

        Countdown.section.classList.remove("flash");

    },450);

}

if(state !== Countdown.previousState){

    updateMessage();

    updateUrgency();

    Countdown.previousState = state;

}

}

function updateMessage(){
    const state =
    Countdown.currentState;

let text =
    Countdown.messages[state];
    

        const message =
    Countdown.elements.message;

if (message.textContent === text) {
    return;
}

message.classList.add("fade");

setTimeout(() => {

    message.textContent = text;

    message.classList.remove("fade");

}, 250);

}

function updateUrgency(){

    const state =
    Countdown.currentState;

    Countdown.section.style.setProperty(
        "--promo-bg",
        `var(--state-${state})`
    );

}

function renderTime(hours, minutes, seconds){

    updateDigit(
        Countdown.elements.hours,
        formatNumber(hours)
    );

    updateDigit(
        Countdown.elements.minutes,
        formatNumber(minutes)
    );

    updateDigit(
        Countdown.elements.seconds,
        formatNumber(seconds)
    );

}

function updateDigit(element, value){

    if(element.textContent === value){
        return;
    }

    element.classList.add("change");

    setTimeout(() => {

        element.textContent = value;

    }, 90);

    setTimeout(() => {

        element.classList.remove("change");

    }, 180);

}

function formatNumber(value){

    return String(value).padStart(2,"0");

}

function getCurrentState(hours, minutes){

    switch(Countdown.duration){

        case 6:

            if(hours === 0 && minutes < 5)
                return "last";

            if(hours === 0 && minutes < 15)
                return "final";

            if(hours < 1)
                return "fast";

            if(hours < 3)
                return "limited";

            return "normal";

        case 12:

            if(hours === 0 && minutes < 15)
                return "last";

            if(hours < 1)
                return "final";

            if(hours < 3)
                return "fast";

            if(hours < 6)
                return "limited";

            return "normal";

        case 24:

            if(hours === 0 && minutes < 15)
                return "last";

            if(hours < 1)
                return "final";

            if(hours < 6)
                return "fast";

            if(hours < 12)
                return "limited";

            return "normal";

        case 48:

    if(hours === 0 && minutes < 15)
        return "last";

    if(hours < 2)
        return "final";

    if(hours < 12)
        return "fast";

    if(hours < 24)
        return "limited";

    return "normal";

        case 72:

    if(hours === 0 && minutes < 15)
        return "last";

    if(hours < 3)
        return "final";

    if(hours < 18)
        return "fast";

    if(hours < 36)
        return "limited";

    return "normal";

    }

    return "normal";

}